export {Typography, Typography as default} from './typography.component';
export {H1, H2, H3, H4, H5, H6} from './typography-variants.component';
export {TypographyClasses} from './constants';

export type {TypographyProps} from './typography.component';
export type {OmittedTypographyProps} from './typography-variants.component';
